var ShellVideo = require('./ShellVideo');

module.exports = ShellVideo;
